var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightBig = function SvgChevronRightBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3904 7.9987L4.86177 13.5273C4.60142 13.7876 4.60142 14.2098 4.86177 14.4701C5.12212 14.7305 5.54423 14.7305 5.80458 14.4701L11.8046 8.4701C12.0649 8.20975 12.0649 7.78764 11.8046 7.52729L5.80458 1.52729C5.54423 1.26694 5.12212 1.26694 4.86177 1.52729C4.60142 1.78764 4.60142 2.20975 4.86177 2.4701L10.3904 7.9987Z"
  })));
};
export default SvgChevronRightBig;